import React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
import { EventType } from "@gp/models";
import TeamIcon from "@components/icons/TeamIcon";
import { formatTeamName } from "@utils/format/formatter";

type QuickPlayCardsTeamsProps = {
	sportData: {
		eventType?: EventType;
		eventName?: string | null;
		showCountryFlag?: boolean;
		teamOneCountryCode?: string;
		teamTwoCountryCode?: string;
		teamOneJerseyTypeAbrv?: string;
		teamTwoJerseyTypeAbrv?: string;
		teamOneName: string;
		teamTwoName: string;
		teamOneGender: number;
		teamTwoGender: number;
	};

	className?: string;
	containerClassName?: string;
	iconClassName?: string;
	teamNameClassName?: string;
};

export const QuickPlayCardsTeams = observer(
	(props: QuickPlayCardsTeamsProps) => {
		const {
			containerClassName = "card--qp__competitor card--bbp__competitor card--qp--nowrap__competitor card--bbp--nowrap__competitor",
			iconClassName = "card--qp__icon card--bbp__icon u-icon u-icon--xmed",
			teamNameClassName = "card--qp__team card--mpt__team card--qp--nowrap__team card--mpt--nowrap__team",
		} = props;

		if (
			props.sportData?.eventType != null &&
			props.sportData?.eventType !== EventType.NORMAL &&
			props.sportData?.eventName != ""
		) {
			return (
				<div className={classNames("event-name", props.className)}>
					{props.sportData.eventName}
				</div>
			);
		}

		return (
			<div>
				<div className={containerClassName}>
					<TeamIcon
						showCountryFlag={props.sportData?.showCountryFlag ?? false}
						flagCode={props.sportData?.teamOneCountryCode}
						jerseyTypeAbrv={props.sportData?.teamOneJerseyTypeAbrv}
						opponentFlagCode={props.sportData?.teamTwoCountryCode}
						opponentJerseyTypeAbrv={props.sportData?.teamTwoJerseyTypeAbrv}
						className={iconClassName}
					/>
					<span className={teamNameClassName}>
						{formatTeamName(
							props.sportData?.teamOneName,
							props.sportData?.teamOneGender,
							props.sportData?.eventType || EventType.NORMAL
						)}
					</span>
				</div>
				<div className={containerClassName}>
					<TeamIcon
						showCountryFlag={props.sportData?.showCountryFlag ?? false}
						flagCode={props.sportData?.teamTwoCountryCode}
						jerseyTypeAbrv={props.sportData?.teamTwoJerseyTypeAbrv}
						opponentFlagCode={props.sportData?.teamOneCountryCode}
						opponentJerseyTypeAbrv={props.sportData?.teamOneJerseyTypeAbrv}
						className={iconClassName}
					/>
					<span className={teamNameClassName}>
						{formatTeamName(
							props.sportData?.teamTwoName,
							props.sportData?.teamTwoGender,
							props.sportData?.eventType || EventType.NORMAL
						)}
					</span>
				</div>
			</div>
		);
	}
);
